import script from "./InfoCardRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCardRow.vue?vue&type=script&setup=true&lang=ts"

import "./InfoCardRow.vue?vue&type=style&index=0&id=75602522&lang=scss"

const __exports__ = script;

export default __exports__